import ShopItem from '../ShopItem';

const materialButtons = {
    'Запись вебинара Вероники Сидоровой «Не/папина дочка»': [ {
        link: '/user/digital/nepapina-dochka-materials',
        text: 'Посмотреть вебинар',
        mod: 'gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    } ],
    'Вебинар Вероники Сидоровой «Не/папина дочка»': [ {
        link: '/user/digital/nepapina-dochka-materials',
        text: 'Посмотреть вебинар',
        mod: 'gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    } ],
    'Запись вебинара Вероники Сидоровой «Деньги в паре»': [ {
        link: '/materials/money-course',
        text: 'Посмотреть материалы',
        mod: 'gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    } ],
    '«Психолог моего психолога» - проект супервизий Вероники Сидоровой': [ {
        link: '/materials/supervisions',
        text: 'Посмотреть материалы',
        mod: 'gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    } ],
    'Материалы из курса Вероники «Про чувства»': [ {
        link: '/materials/feelings-course-podcasts',
        text: 'Слушать',
        mod: 'gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    }, {
        link: '/materials/feelings-course-video',
        text: 'Смотреть',
        mod: 'transparent-gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    } ],
    'Курс Вероники «Про тело», второй поток': [ {
        link: '/body-course-materials',
        text: 'Посмотреть материалы',
        mod: 'gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    } ],
    'Курс о семейной системе «Разрушить Нельзя Строить»': [ {
        link: '/user/digital/semeynaya-sistema-materials',
        text: 'Посмотреть материалы',
        mod: 'gold',
        isActive: (digital) => digital.files.slice(1).some(file => file.isActive)
    } ],
    'Аудиокнига «10 писем к тебе»': [{
        link: '/book',
        text: 'Слушать',
        mod: 'gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    }],
    'RGlnaXRhbFR5cGU6NDA=': [{
        link: '/user/digital/webinar_protelo_rec',
        text: 'Посмотреть материалы',
        mod: 'gold',
        isActive: (digital) => digital.files.slice(1).some(file => file.isActive)
    }],
    'RGlnaXRhbFR5cGU6NDE=': [{
        link: '/user/digital/body-course-3',
        text: 'Слушать',
        mod: 'gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    }],
    'RGlnaXRhbFR5cGU6NDI=': [{
        link: '/user/digital/digital_book',
        text: 'Скачать книгу',
        mod: 'gold',
        isActive: (digital) => digital.files.some(file => file.isActive)
    }]
};

export default (purchase) => {
    const buttons = [];
    const { digital } = purchase;
    const name = digital.name;
    const id = digital.id;
    if (purchase.hasTelegramChannel) {
        buttons.push({link: digital.link, text: 'Перейти в телеграм', mod: 'link'});
    }
    if (purchase.hasWebinarLink) {
        buttons.push({link: digital.webinarLink, text: 'Посмотреть вебинар', mod: 'gold'});
    }
    if (ShopItem.isSupervision(name)) {
        buttons.push({
            link: `/materials/supervisions/${digital.url}`,
            text: 'Посмотреть материалы',
            mod: 'gold',
            isActive: (digital) => digital.files.some(file => file.isActive)
        })
    }
    if (ShopItem.isFamilySystem(name)) {
        buttons.push({
            link: `/user/digital/${digital.url}`,
            text: 'Посмотреть материалы',
            mod: 'gold',
            isActive: (digital) => digital.files.some(file => file.isActive)
        })
    }
    if (materialButtons[name] || materialButtons[id]) {
        const courseMaterialButtons = materialButtons[name] || materialButtons[id];
        courseMaterialButtons.forEach(cmb => {
            if (cmb.isActive(digital)) {
                buttons.push(cmb);
            }
        })
    }
    return buttons;
}
